import { DictionaryItem } from "@sa/rep-mdm";

export function getCalendarParameterSelection(selection: number[], calendarOriginItems: DictionaryItem[]) {
  let result = new Set(selection);

  const scan = (id: number) => {
    const item = calendarOriginItems.find((item) => Number(item.id) === id);

    if (item != null) {
      const parent = item.getValue<number>("parent");

      if (parent != null) {
        result.add(parent);
        scan(parent);
      }
    }
  };

  for (let i = 0; i < selection.length; i++) {
    scan(selection[i]);
  }

  return [...result];
}
